import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, FileText, Tag, Settings, Plus } from 'lucide-react';
import UploadModal from '../files/UploadModal';
import { useCategoryStore } from '../../stores/category-store';
import { useI18n } from '../../i18n';

const MobileTabBar: React.FC = () => {
  const [showUpload, setShowUpload] = useState(false);
  const { activeCategory } = useCategoryStore();
  const { t } = useI18n();

  return (
    <>
      {/* Bottom tab bar */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 shadow-sm pb-[env(safe-area-inset-bottom)]">
        <div className="relative h-14 flex items-center justify-around text-[10px] md:text-xs select-none">
          <NavLink
            to="/uadmin/"
            className={({ isActive }) => `flex flex-col items-center justify-center h-full w-16 ${isActive ? 'text-teal-600' : 'text-gray-500'}`}
            aria-label={t('dashboard')}
          >
            <Home size={20} />
            <span className="mt-0.5">{t('dashboard')}</span>
          </NavLink>

          <NavLink
            to="/uadmin/categories"
            className={({ isActive }) => `flex flex-col items-center justify-center h-full w-16 ${isActive ? 'text-teal-600' : 'text-gray-500'}`}
            aria-label={t('fileBrowser')}
          >
            <FileText size={20} />
            <span className="mt-0.5">{t('fileBrowser')}</span>
          </NavLink>

          {/* FAB */}
          <button
            onClick={() => setShowUpload(true)}
            className="absolute -top-5 left-1/2 -translate-x-1/2 h-12 w-12 rounded-full bg-teal-600 text-white shadow-md flex items-center justify-center active:scale-95"
            aria-label={t('upload')}
          >
            <Plus size={22} />
          </button>

          <NavLink
            to="/uadmin/tags"
            className={({ isActive }) => `flex flex-col items-center justify-center h-full w-16 ${isActive ? 'text-teal-600' : 'text-gray-500'}`}
            aria-label={t('tags')}
          >
            <Tag size={20} />
            <span className="mt-0.5">{t('tags')}</span>
          </NavLink>

          <NavLink
            to="/uadmin/settings"
            className={({ isActive }) => `flex flex-col items-center justify-center h-full w-16 ${isActive ? 'text-teal-600' : 'text-gray-500'}`}
            aria-label={t('settings')}
          >
            <Settings size={20} />
            <span className="mt-0.5">{t('settings')}</span>
          </NavLink>
        </div>
      </nav>

      {showUpload && (
        <UploadModal
          onClose={() => setShowUpload(false)}
          category={activeCategory || undefined}
        />
      )}
    </>
  );
};

export default MobileTabBar;


